import * as Yup from "yup";
import {
  emailValidation,
  phoneValidation,
  singleNameValidation,
  addressValidation,
} from "../../../Utils/ValidationSchema";

const profileValidationSchema = (t) =>
  Yup.object({
    firstName: singleNameValidation("first_name"),
    lastName: singleNameValidation("last_name"),
    email: emailValidation(),
    phoneNumber: phoneValidation(),
    address: addressValidation("address"),
    birthday: Yup.date()
      .max(new Date(), t("validation-error-messages:birthday_future"))
      .required(t("validation-error-messages:birthday_required")),
  });

export default profileValidationSchema;
